module.exports = __webpack_public_path__ + "static/media/view.7288fbb3.md";